import { createSlice } from '@reduxjs/toolkit';
// utils
import apiContact from '../../api/contact';
import { JanusHelper, plugins, Janus } from 'janus-helper'
import $ from 'jquery'
import { handleMusicCalling } from '../../utils/getFileSound';
const initialState = {
    doCall: null,
    doHangup: null,
    doDecline: null,
    doAnswer: null,
    toggleMute: null,
    toggleHold: null,
    transfer: null,
    calling: false,
    status: null,
    infoContact: {},
    outGoingCall: false,
    incomingCall: false,
    answered: false,
    isConnect: false,
    message: "",
    isHold: false,
    isMuted: false,
    isTransfer: false,
    sendDtmf: null
};
//
// name : teen store quan li

const slice = createSlice({
    name: 'janus',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.message = action.payload;
        },
        initializeJanus(state, action) {

            state.doCall = action.payload.doCall;
            state.doHangup = action.payload.doHangup;
            state.doDecline = action.payload.doDecline;
            state.doAnswer = action.payload.doAnswer;
            state.toggleMute = action.payload.toggleMute;
            state.toggleHold = action.payload.toggleHold;
            state.transfer = action.payload.transfer;
            state.sendDtmf = action.payload.sendDtmf;
           
        },
        statusAnswered(state, action) {
            state.answered = true;
            handleMusicCalling(false);
        },
        statusRegistered(state, action) {
            state.isConnect = true;
        },
        statusIncomingCall(state, action) {
            state.calling = true;
            state.infoContact = true;
            state.outGoingCall = false;
            state.incomingCall = true;
            handleMusicCalling(true);
            const uri = action.payload.name;
            const regex = /sip:(\d+)@/; // matches "sip:", followed by one or more digits (\d+), followed by "@"
            const match = uri.match(regex);
            if (match) {
                const number = match[1]; // the first capturing group (\d+) contains the number
                state.infoContact = { name: "", phone: number};
                
            } else {
                state.infoContact = { name: "", phone: "Không xác định"};
            }

        },
        statusHangup(state, action) {
            state.answered = false;
            state.calling = false;
            state.infoContact = null;
            state.outGoingCall = false;
            state.incomingCall = false;
            handleMusicCalling(false);
        },
        statusCalling(state, action) {
            state.calling = action.payload.statusCall;
            console.log(action.payload.infoContact);
            if (action.payload.infoContact) {
                //state.infoContact = { name: "Không xác định", "phone": action.payload.phone };
                state.infoContact = action.payload.infoContact;
            } else {
                state.infoContact = { name: "", phone: action.payload.phone };
            }

            state.outGoingCall = action.payload.outGoingCall;
            state.incomingCall = action.payload.incomingCall;

        },
        statusDecline(state, action) {
            state.calling = false;
            state.infoContact = null;
            state.outGoingCall = false;
            state.incomingCall = false;
            state.answered = false;
            handleMusicCalling(false);
        },
        statusAnswer(state, action) {
            state.answered = true;
            handleMusicCalling(false);
        },
        statusHolding(state, action) {
            state.isHold = action.payload.holding
        },
        statusMute(state, action) {
            state.isMuted = action.payload.muted
        },
        statusTransferring(state, action) {
            state.isTransfer = action.payload.transferring
        }
    }
});

// Reducer
export default slice.reducer;


export const InitJanus = ({ ipSip, sip, secret }) => (dispatch) => {

    var sipcall = null;
    var registered = false;
    var masterId = null, helpers = {}, helpersCount = 0;
    var localTracks = {}, localVideos = 0, remoteTracks = {}, remoteVideos = 0;
    var janus = null;
    var incoming = null;
    var checkHold = null;
    var count = 0;
    var mid = 0;
    var referId = null;
    var jsepp = null;
    var offerlessInvite = false;
    var doAudio2 = null;
    const registerUsername = (ipSip, sip, secret) => {
        var port = 5060;
        var sipserver = null;
        var username = null;
        var password = null;
        var register = null;

        sipserver = "sip:" + ipSip;
        username = "sip:" + sip + "@" + ipSip;
        password = secret;
        register = {
            request: "register",
            username: username
        };
        var authuser = sip;
        if (authuser !== "") {
            register.authuser = authuser;
        }
        var displayname = sip;
        if (displayname !== "") {
            register.display_name = displayname;
        }
        register["secret"] = password;
        register["proxy"] = sipserver;
        sipcall.send({ message: register });

    };
    const doHangup = () => {
        var hangup = { request: "hangup" };
        sipcall.send({ message: hangup });
        sipcall.hangup();
        dispatch(slice.actions.statusHangup());
    }
    const doCall = (username, infoContact) => {
        var helperId = null;
        var handle = helperId ? helpers[helperId].sipcall : sipcall;
     
        var prefix = helperId ? ("[Helper #" + helperId + "]") : "";
        var suffix = helperId ? ("" + helperId) : "";
        $('#peer' + suffix).attr('disabled', true);
        $('#call' + suffix).attr('disabled', true).unbind('click');
        var usernameAc = null;
        usernameAc = "sip:" + username + "@" + ipSip;
        console.log(usernameAc);
        handle.doAudio = true;
        let tracks = [{ type: 'audio', capture: true, recv: true }];
        handle.createOffer(
            {
                media: {
                    audioSend: true,
                    audioRecv: true, // We DO want audio
                    videoSend: false,
                    videoRecv: false, // We MAY want video
                },
                success: function (jsep) {
                    Janus.debug("Got SDP!", jsep);
                    var body = { request: "call", uri: usernameAc };
                    body["autoaccept_reinvites"] = false;
                    handle.send({ message: body, jsep: jsep });
                },
                error: function (error) {
                    Janus.error(prefix + "WebRTC error...", error);
                    dispatch(slice.actions.hasError("WebRTC error... " + error.message));
                    console.log("WebRTC error... " + error.message, "danger");
                }
            }
        );
        dispatch(slice.actions.statusCalling({ statusCall: true, outGoingCall: true, IncomingCall: false, infoContact: infoContact, phone: username }));
    }
    const doDecline = () => {
        console.log('decline decline decline')
        var body = { request: "decline", referId: referId };
        sipcall.send({ message: body });
        dispatch(slice.actions.statusDecline());
    }

    const doAnswer = () => {
        console.log(offerlessInvite)
        var sipcallAction = offerlessInvite ? sipcall.createOffer : sipcall.createAnswer;
        sipcallAction({
            jsep: jsepp,
            media: {
                audioSend: true,
                audioRecv: true, // We DO want audio
                videoSend: false,
                videoRecv: false, // We MAY want video
            },
            success: function success(jsep) {
                Janus.debug('[SIP] Got SDP ' + jsep.type + '! audio=' + true + ', video=' + false);
                Janus.debug('[SIP]' + jsep);
                var body = { request: 'accept' };
                sipcall.send({ message: body, jsep: jsep });
            },
            error: function error(_error3) {
                Janus.error('[SIP] WebRTC error:', _error3);
                dispatch(slice.actions.hasError(_error3));
                // Don't keep the caller waiting any longer, but use a 480 instead of the default 486 to clarify the cause
                var body = { request: 'decline', code: 480 };
                sipcall.send({ message: body });
            }
        });
        dispatch(slice.actions.statusAnswer());
    }
    const toggleMute = () => {
        let muted = sipcall.isAudioMuted();
        Janus.log((muted ? "Unmuting" : "Muting") + " local stream...");
        if (muted) {
            sipcall.unmuteAudio();
            dispatch(slice.actions.statusMute({ muted: false }));
        } else {
            sipcall.muteAudio();
            dispatch(slice.actions.statusMute({ muted: true }));
        }
        muted = sipcall.isAudioMuted();
    }
    const toggleHold = () => {
        if (checkHold != "holding") {
            var holdaction = { request: "hold", direction: "sendonly" };
            sipcall.send({ message: holdaction });
        } else {
            var unholdaction = { request: "unhold" };
            sipcall.send({ message: unholdaction });
        }
    }

    const transfer = (transferToNumber) => {
        var address = "sip:" + transferToNumber + "@" + ipSip;
        if (address === '') { return; }
        var msg = { request: "transfer", uri: address };
        sipcall.send({ message: msg });
    }

    const sendDtmf = (number) => {
        sipcall.dtmf({ dtmf: { tones: number } });
    }
    const mediaState = () => { }
    const webrtcState = () => { }
    const onmessage = () => { }
    const onlocalstream = () => { }
    const onremotestream = () => { }
    Janus.init({
        debug: "all", callback: function () {
            if (!Janus.isWebrtcSupported()) {
                console.log("No WebRTC support... ", "danger");
                return;
            }
            janus = new Janus({
                server: 'https://janus3.voip24h.vn/janus', // set janus server wss url address 
                success: function () {
                    janus.attach({
                        plugin: "janus.plugin.sip",
                        success: function (pluginHandle) {
                            sipcall = pluginHandle;
                            console.log("Plugin attached! (" + sipcall.getPlugin() + ", id=" + sipcall.getId() + ")");
                            registerUsername(ipSip, sip, secret);

                        },
                        error: function (error) {
                            Janus.error("  -- Error attaching plugin...", error);
                            dispatch(slice.actions.hasError("  -- Error attaching plugin... " + error));
                        },
                        mediaState: (medium, on) => {
                            Janus.log(`[SIP] Janus ${on ? 'started' : 'stopped'} receiving our ${medium}`);
                            mediaState(medium, on);
                        },
                        webrtcState: (on) => {
                            Janus.log(`[SIP] Janus says our WebRTC PeerConnection is ${on ? 'up' : 'down'} now`);
                            webrtcState(on);
                        },
                        consentDialog: function (on) {
                            Janus.debug("Consent dialog should be " + (on ? "on" : "off") + " now");
                        },
                        iceState: function (state) {
                            Janus.log("ICE state changed to " + state);
                        },

                        webrtcState: function (on) {
                            Janus.log("Janus says our WebRTC PeerConnection is " + (on ? "up" : "down") + " now");
                        },
                        slowLink: function (uplink, lost, mid) {
                            Janus.warn("Janus reports problems " + (uplink ? "sending" : "receiving") +
                                " packets on mid " + mid + " (" + lost + " lost packets)");
                        },
                        onmessage: function (msg, jsep) {
                            jsepp = jsep;
                            Janus.debug(" ::: Got a message :::", msg);
                            var error = msg["error"];
                            if (error) {
                                if (!registered) {

                                } else {
                                    // Reset status
                                    sipcall.hangup();
                                }
                                return;
                            }
                            var callId = msg["call_id"];
                            var result = msg["result"];
                            if (result && result["event"]) {
                                var event = result["event"];
                                console.log(event)
                                if (event === 'registration_failed') {
                                    // if(result["code"] == 403){
                                    //     registerUsername(ipSip+":5999", sip, secret);
                                    // }
                                    
                                    Janus.warn("Registration failed: " + result["code"] + " " + result["reason"]);
                                    return;
                                }
                                if (event === 'registered') {
                                    Janus.log("Successfully registered as " + result["username"] + "!");
                                    dispatch(slice.actions.statusRegistered());
                                    if (!registered) {
                                        registered = true;
                                        masterId = result["master_id"];
                                    }
                                } else if (event === 'calling') {
                                    Janus.log("Waiting for the peer to answer...");
                                    // TODO Any ringtone?
                                } else if (event === 'incomingcall') {
                                    Janus.log("Incoming call from " + result["username"] + "!");
                                    sipcall.callId = callId;
                                    var doAudio = true, doVideo = true;
                                    offerlessInvite = false;
                                    if (jsep) {
                                        doAudio = (jsep.sdp.indexOf("m=audio ") > -1);
                                        Janus.debug("Audio " + (doAudio ? "has" : "has NOT") + " been negotiated");
                                    } else {
                                        Janus.log("This call doesn't contain an offer... we'll need to provide one ourselves");
                                        offerlessInvite = true;
                                        doVideo = false;
                                    }
                                    var transfer = "";
                                    var referredBy = result["referred_by"];
                                    if (referredBy) {
                                        transfer = " (referred by " + referredBy + ")";
                                        transfer = transfer.replace(new RegExp('<', 'g'), '&lt');
                                        transfer = transfer.replace(new RegExp('>', 'g'), '&gt');
                                    }
                                    var rtpType = "";
                                    var srtp = result["srtp"];
                                    if (srtp === "sdes_optional")
                                        rtpType = " (SDES-SRTP offered)";
                                    else if (srtp === "sdes_mandatory")
                                        rtpType = " (SDES-SRTP mandatory)";
                                    // Notify user
                                    // bootbox.hideAll();
                                    var extra = "";
                                    if (offerlessInvite) {
                                        extra = " (no SDP offer provided)"
                                    }
                                    doAudio2 = (jsep.sdp.indexOf("m=audio ") > -1);

                                    dispatch(slice.actions.statusIncomingCall({ name: result["username"] }));
                                } else if (event === 'accepting') {
                                    // Response to an offerless INVITE, let's wait for an 'accepted'
                                } else if (event === 'progress') {
                                    Janus.log("There's early media from " + result["username"] + ", wairing for the call!", jsep);
                                    // Call can start already: handle the remote answer
                                    if (jsep) {
                                        sipcall.handleRemoteJsep({ jsep: jsep, error: doHangup });
                                    }
                                    //message_notify("Đang kết nối...", "success");
                                } else if (event === 'accepted') {
                                    Janus.log(result["username"] + " accepted the call!", jsep);

                                    if (jsep) {
                                        sipcall.handleRemoteJsep({ jsep: jsep, error: doHangup });
                                    }

                                    sipcall.callId = callId;
                                    dispatch(slice.actions.statusAnswered({ answered: true }));
                                } else if (event === 'updatingcall') {
                                    Janus.log("Got re-INVITE");
                                    var doAudio = (jsep.sdp.indexOf("m=audio ") > -1),
                                        doVideo = (jsep.sdp.indexOf("m=video ") > -1);
                                    let tracks = [];
                                    if (doAudio && !sipcall.doAudio) {
                                        sipcall.doAudio = true;
                                        tracks.push({ type: 'audio', capture: true, recv: true });
                                    }
                                    if (doVideo && !sipcall.doVideo) {
                                        sipcall.doVideo = true;
                                        tracks.push({ type: 'video', capture: true, recv: true });
                                    }
                                    sipcall.createAnswer(
                                        {
                                            jsep: jsep,
                                            tracks: tracks,
                                            success: function (jsep) {
                                                Janus.debug("Got SDP " + jsep.type + "! audio=" + doAudio + ", video=" + doVideo + ":", jsep);
                                                var body = { request: "update" };
                                                sipcall.send({ message: body, jsep: jsep });
                                            },
                                            error: function (error) {
                                                Janus.error("WebRTC error:", error);
                                                dispatch(slice.actions.hasError("WebRTC error:" + error));
                                            }
                                        });
                                    dispatch(slice.actions.statusIncomingCall({}));
                                } else if (event === 'transfer') {
                                    var referTo = result["refer_to"];
                                    var referredBy = result["referred_by"] ? result["referred_by"] : "an unknown party";
                                    referId = result["refer_id"];
                                    var replaces = result["replaces"];
                                    var extra = ("referred by " + referredBy);
                                    if (replaces)
                                        extra += (", replaces call-ID " + replaces);
                                    extra = extra.replace(new RegExp('<', 'g'), '&lt');
                                    extra = extra.replace(new RegExp('>', 'g'), '&gt');

                                } else if (event === 'hangup') {
                                    if (incoming != null) {
                                        incoming.modal('hide');
                                        incoming = null;
                                    }
                                    Janus.log("Call hang up (" + result["code"] + " " + result["reason"] + ")!");
                                    console.log(result["code"] + " " + result["reason"], "danger");
                                    count = 0;
                                    // Reset status
                                    sipcall.hangup();
                                    dispatch(slice.actions.statusTransferring({ transferring: false }));
                                    dispatch(slice.actions.statusHangup());
                                } else if (event === 'messagedelivery') {
                                    // message delivery status
                                    let reason = result["reason"];
                                    let code = result["code"];
                                    let callid = msg['call_id'];
                                    if (code == 200) {
                                        //message_notify(`${callid} Delivery Status: ${code} ${reason}`, "success");
                                    } else {
                                        //message_notify(`${callid} Delivery Status: ${code} ${reason}`, "danger");
                                    }
                                } else if (event === 'transferring') {
                                    dispatch(slice.actions.statusTransferring({ transferring: true }));
                                }
                                if (event === 'holding') {
                                    checkHold = "holding";
                                    dispatch(slice.actions.statusHolding({ holding: true }));
                                } else {
                                    checkHold = "";
                                    dispatch(slice.actions.statusHolding({ holding: false }));
                                }
                            }
                        },
                        onlocalstream: function (stream) {
                            Janus.log('Janus Remote stream detected');
                            Janus.log(stream);
                            //$('#audiostream').append('<audio class="hide" id="peervideom" autoplay playsinline/>');
                            //Janus.attachMediaStream($('#peervideom').get(0), stream);
                        },
                        onremotestream: function (stream) {
                            Janus.log('Janus Remote stream detected');
                            Janus.log(stream);
                            $('#audiostream').append('<audio class="hide" id="peervideom" autoplay playsinline/>');
                            Janus.attachMediaStream($('#peervideom').get(0), stream);
                        },
                        oncleanup: function () {
                            Janus.log(" ::: Got a cleanup notification :::");
                        }

                    })
                },
                error: function (error) { console.log(error); dispatch(slice.actions.hasError(error)); },
                destroyed: function () { window.location.reload(); }
            });
            dispatch(slice.actions.initializeJanus({ doCall: doCall, doHangup: doHangup, doDecline: doDecline, doAnswer: doAnswer, toggleMute: toggleMute, toggleHold: toggleHold, transfer: transfer, sendDtmf: sendDtmf }));
        }

    });
};

